var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","title":_vm.title},on:{"click":_vm.toggleBookmark}},[_c('v-icon',[_vm._v(_vm._s(_vm.currentIcon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }